/**
 * 把参数转化为querystring
 *
 * @param {any} url
 * @param {any} queryObj
 * @returns
 */
function stringify(queryObj: any, u = '') {
  const hashArray = u.match(/#.*/g);
  let result;
  let hash = '';
  let url = u;

  if (hashArray) {
    [hash] = hashArray;
    url = u.replace(hash, '');
  }
  result = url;

  if (typeof queryObj === 'object') {
    const keys = Object.keys(queryObj);
    const qArray: any[] = [];

    keys.forEach((k) => {
      const type = typeof queryObj[k];
      if (type !== 'undefined' && type !== 'object') {
        qArray.push(`${k}=${encodeURIComponent(queryObj[k])}`);
      }
    });

    const qstr = qArray.join('&');
    if (qstr) {
      result = `${url}${url.indexOf('?') === -1 ? '?' : '&'}${qstr}`;
    }
  }
  return `${result}${hash}`;
}

/**
 * 解析url的参数
 *
 * @param {any} [url = window.location.href]
 * @returns
 */
function parse(url = window.location.href) {
  const q: any = {};
  url.replace(/[?&](.+?)=([^&#]*)/g, ($, k, v) => {
    q[k] = decodeURIComponent(v);
    return '';
  });
  return q;
}

export { stringify, parse };
